import { createFileRoute, Outlet, useParams } from "@tanstack/react-router";
import { RecordWorkspaceAssetsTable } from "@/features/records/components";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/assets/(asset)/$assetId/workspace/records/$recordId/workspace/assets",
)({
	component: RecordWorkspaceAssetsTab,
	validateSearch: (search: Record<string, unknown>) => ({
		q: typeof search.q === "string" ? search.q : undefined,
	}),
});

/**
 * Asset-hosted Record workspace Assets tab — view-only association list.
 * Row open nests an asset drawer under this tab; Workspace jumps to the
 * top-level org asset workspace.
 */
function RecordWorkspaceAssetsTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/assets/(asset)/$assetId/workspace/records/$recordId/workspace/assets",
	});

	return (
		<div className="relative flex min-h-0 w-full flex-1 flex-col">
			<RecordWorkspaceAssetsTable
				orgId={params.orgId}
				recordId={params.recordId}
				hostAssetId={params.assetId}
				assetNavTarget="assetScoped"
				syncSearchToUrl={false}
			/>
			<Outlet />
		</div>
	);
}
